import React from 'react';
import { QuoteIcon } from 'lucide-react';
export const Testimonials = ({
  openModal
}) => {
  return <section className="mb-10" data-id="element-375">
      <h2 className="text-xl font-bold text-blue-800 mb-6" data-id="element-376">
        Nederlandse expert leert baasjes de oplossing tijdens online presentatie
      </h2>
      <div className="space-y-6 mb-6" data-id="element-377">
        <div className="bg-gray-50 p-5 rounded-lg border-l-4 border-blue-300" data-id="element-378">
          <div className="flex flex-col md:flex-row mb-3" data-id="element-379">
            <div className="mb-4 md:mb-0 md:mr-4 flex-shrink-0 flex justify-center" data-id="element-380">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kJ5b6tBbH8hDNt52JG84mT/Scherm%C2%ADafbeelding_2025-08-15_om_15.44.02.png" alt="Amee de Bruijn" className="w-16 h-16 rounded-full object-cover" data-id="element-381" />
            </div>
            <div data-id="element-382">
              <QuoteIcon className="w-6 h-6 text-blue-300 mr-2 flex-shrink-0 float-left" data-id="element-383" />
              <p className="italic" data-id="element-384">
                "Ik zie elke dag honden die agressief zijn geworden door
                verkeerde training. Mensen willen het beste voor hun hond. Maar
                ze krijgen slecht advies."
              </p>
              <p className="text-right text-sm font-medium mt-2" data-id="element-385">
                - Amee de Bruijn, Hondengedragsdeskundige
              </p>
            </div>
          </div>
        </div>
      </div>
      <p className="mb-6 leading-relaxed" data-id="element-386">
        Amee de Bruijn werkt al jaren met honden. Ook geeft ze online
        presentaties waarin ze hondenbaasjes helpt om hun hond beter te
        begrijpen.
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-387">
        Amee heeft al meer dan 15.000 mensen geholpen. Ze gebruikt nooit
        straffen. In plaats daarvan leert ze baasjes "hondentaal". Zo kunnen ze
        zonder straffen of corrigeren hun hond laten weten dat die iets niet
        hoeft te doen. "Als je dit op een manier doet die voor de hond
        natuurlijk is dan snapt hij dat meteen" zegt Amee. "Ook leren mensen hoe
        ze hun hond moeten lezen. Dan begrijpen ze wat hij denkt of voelt. Dit
        maakt alles makkelijker."
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-388">
        "Honden willen samenwerken," legt ze uit tijdens haar online
        presentatie. "Je hoeft ze niet te straffen. Je moet alleen hun taal
        leren spreken."
      </p>
      <h2 className="text-xl font-bold text-blue-800 mb-4" data-id="element-389">
        Samenwerken in plaats van straffen
      </h2>
      <p className="mb-6 leading-relaxed" data-id="element-390">
        Wetenschap laat zien dat je beter kan samenwerken. Dit begint bij je
        hond begrijpen en leren hoe je met hem communiceert.
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-391">
        "Daarom geef ik af en toe gratis online webinars over hondentaal. Hierin
        leer ik mensen hoe ze met liefdevolle communicatie probleemgedrag kunnen
        voorkomen, zonder straffen." zegt Amee. "En de band met je hond wordt
        ook nog eens sterker."
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-392">
        <a href="https://stresslessdogs.nl/mcc-gpm-adv1" className="text-blue-600 cursor-pointer underline" target="_blank" rel="noopener noreferrer" onClick={openModal} data-id="element-393">
          Ook deze week geef ik deze online presentatie nog een paar keer per
          dag. (Klik hier om te zien of er nog plek is)
        </a>
      </p>
      <p className="mb-6 leading-relaxed font-semibold text-blue-800" data-id="element-394">
        De waarheid: Honden hebben meer baat bij een begripvol baasje die hun
        taal spreekt, luistert en samenwerkt dan bij een baas die streng is.
      </p>
    </section>;
};